import { PayloadAction } from "@reduxjs/toolkit"
import { SagaIterator } from "redux-saga"
import { call, takeLeading } from "redux-saga/effects"
import { actions, ProcessCloudProviderSessionPayload } from "~/redux/process"
import { restoreVNZAuthenticationState } from "~/redux/saga/processVNZ"

export function* watchProcessCloudProviderSession() {
  yield takeLeading(
    actions.processCloudProviderSession.type,
    processCloudProviderSession
  )
}

function* processCloudProviderSession(
  action: PayloadAction<ProcessCloudProviderSessionPayload>
): SagaIterator<void> {
  yield call(restoreVNZAuthenticationState)
}
